/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTokenSubstituteRequest
 */
export interface GetTokenSubstituteRequest {
    /**
     * 企業コード
     * @type {string}
     * @memberof GetTokenSubstituteRequest
     */
    companyCode?: string;
}

/**
 * Check if a given object implements the GetTokenSubstituteRequest interface.
 */
export function instanceOfGetTokenSubstituteRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetTokenSubstituteRequestFromJSON(json: any): GetTokenSubstituteRequest {
    return GetTokenSubstituteRequestFromJSONTyped(json, false);
}

export function GetTokenSubstituteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTokenSubstituteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyCode': !exists(json, 'company_code') ? undefined : json['company_code'],
    };
}

export function GetTokenSubstituteRequestToJSON(value?: GetTokenSubstituteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_code': value.companyCode,
    };
}

